import { useState, Dispatch, SetStateAction } from "react";
import { MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState } from "material-react-table";

export type CMSOrderBy = { createdAt?: "asc" | "desc"; updatedAt?: "asc" | "desc"; title?: "asc" | "desc" };

export type CMSPagesTableState = {
    pagination: MRT_PaginationState;
    setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
    sorting: MRT_SortingState;
    setSorting: Dispatch<SetStateAction<MRT_SortingState>>;
    columnFilters: MRT_ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<MRT_ColumnFiltersState>>;
    filters: CMSPagesTableFilters;
    orderBy: CMSOrderBy;
};

export type CMSPagesTableFilters = {
    title: string;
    url: string;
    sectorId: number | undefined;
    status: "active" | "draft" | undefined;
};

export const useCMSPagesTableState = (defaultPageSize = 20): CMSPagesTableState => {
    const [pagination, setPagination] = useState<MRT_PaginationState>({ pageIndex: 0, pageSize: defaultPageSize });
    const [sorting, setSorting] = useState<MRT_SortingState>([{ id: "createdAt", desc: true }]);
    const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);

    const titleFilter = (columnFilters.find((f) => f.id === "title")?.value as string) || "";
    const urlFilter = (columnFilters.find((f) => f.id === "url")?.value as string) || "";
    const sectorFilterRaw = (columnFilters.find((f) => f.id === "sectors")?.value as string) || "";
    const sectorId =
        typeof sectorFilterRaw === "string" && sectorFilterRaw.trim() !== "" ? Number(sectorFilterRaw) : undefined;
    const statusFilterRaw = columnFilters.find((f) => f.id === "status")?.value as string | undefined;
    const status = statusFilterRaw === "active" || statusFilterRaw === "draft" ? statusFilterRaw : undefined;

    const orderBy: CMSOrderBy = {};
    sorting.forEach((sort) => {
        if (sort.id === "createdAt") orderBy.createdAt = sort.desc ? "desc" : "asc";
        if (sort.id === "updatedAt") orderBy.updatedAt = sort.desc ? "desc" : "asc";
        if (sort.id === "title") orderBy.title = sort.desc ? "desc" : "asc";
    });

    return {
        pagination,
        setPagination,
        sorting,
        setSorting,
        columnFilters,
        setColumnFilters,
        filters: {
            title: titleFilter,
            url: urlFilter,
            sectorId,
            status,
        },
        orderBy,
    };
};
